module.exports = __webpack_public_path__ + "static/media/icon-total-0.039884e1.svg";